import React, { useState, useRef, useEffect, useMemo, useCallback} from 'react';
import { render } from 'react-dom';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component

import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS


  
const Hw3 = () => {
  const gridRef = useRef(); // Optional - for accessing Grid's API
  var [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row

  // var rowData = [
  rowData = [
      { id: 'aa', make: 'Toyota', model: 'Celica', price: 35000 },
    { id: 'bb', make: 'Ford', model: 'Mondeo', price: 32000 },
    { id: 'cc', make: 'Porsche', model: 'Boxter', price: 72000 },
    { id: 'dd', make: 'BMW', model: '5 Series', price: 59000 },
    { id: 'ee', make: 'Dodge', model: 'Challanger', price: 35000 },
    { id: 'ff', make: 'Mazda', model: 'MX5', price: 28000 },
    { id: 'gg', make: 'Horse', model: 'Outside', price: 99000 },
  ];
  
  
  const gridOptions = {
    // PROPERTIES
    // Objects like myRowData and myColDefs would be created in your application
    //rowData: myRowData,
    // columnDefs: myColDefs,
    pagination: true,
    rowSelection: 'single',

    columnDefs: [
      { field: 'id' },
      { field: 'make' },
      { field: 'model' },
      { field: 'price', filter: 'agNumberColumnFilter' },
    ],

    defaultColDef: {
      flex: 2,
      editable: true,
      sortable: true,
      filter: true,
    },

    animateRows: true,
    getRowNodeId: function (data) {
      return data.id;
    },
  
    rowData: rowData,

    // EVENTS
    // Add event handlers
    onRowClicked: event => console.log('A row was clicked'),
    onColumnResized: event => console.log('A column was resized'),
    onGridReady: event => console.log('The grid is now ready'),
    //onCellClicked: event =>cellClickedListener, // Optional - registering for Grid Event

    // CALLBACKS
    // isScrollLag: () => false,

}

//function updateSort() {
  const updateSort = useCallback( e => {
    gridOptions.api.refreshClientSideRowModel('sort');
}, []);
//}

//function setDataOnFord() {
//const setDataOnFord = useCallback( e => {

  //}

  //function updateFilter() {
    const updateFilter = useCallback( e => {
      gridOptions.api.refreshClientSideRowModel('filter');
    }, []);
  //}


  // // Each Column Definition results in one Column.
  // const [columnDefs, setColumnDefs] = useState([
  //   {field: 'id', filter: true},
  //   {field: 'make', filter: true, editable: true},
  //   {field: 'model', filter: true, editable: true},
  //   {field: 'price', editable: true}
  // ]);
 
  const initialUsers = [
    // { id: 1, name: "Luis", topic: "Topic1", message: "Mensaje1" },
    // { id: 2, name: "Maria", topic: "Topic2", message: "Mensaje2" },
    // { id: 1, topic: "Topic1", message: "Mensaje1" },
    // { id: 2, topic: "Topic2", message: "Mensaje2" },
    { id: 'aa', make: 'Toyota', model: 'Celica', price: 35000 },
    { id: 'bb', make: 'Ford', model: 'Mondeo', price: 32000 },
    { id: 'cc', make: 'Porsche', model: 'Boxter', price: 72000 },
    { id: 'dd', make: 'BMW', model: '5 Series', price: 59000 },
    { id: 'ee', make: 'Dodge', model: 'Challanger', price: 35000 },
    { id: 'ff', make: 'Mazda', model: 'MX5', price: 28000 },
    { id: 'gg', make: 'Horse', model: 'Outside', price: 99000 },
];

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo( ()=> ({
      sortable: true
    }));
 
  // Example of consuming Grid Event
  const cellClickedListener = useCallback( event => {
    console.log('cellClicked', event);
  }, []);
 
  // Example load data from sever
  useEffect(() => {
    fetch('https://www.ag-grid.com/example-assets/row-data.json')
    .then(result => result.json())
    // .then(rowData => setRowData(rowData))
    .then(rowData => setRowData(initialUsers))
  }, []);
 
  // Example using Grid's API
  const buttonListener1 = useCallback( e => {
    console.log("buttonListener1");
    gridRef.current.api.deselectAll();
  }, []);

  const buttonListener2 = useCallback( e => {
    console.log("buttonListener2");
    gridRef.current.api.updateRowData({
      add: [{ make: 'BMW', model: 'S2', price: '63000' }]
         });
}, []);
 
// const updateEvenRowData = useCallback( e => {
//   //let newRowData = this.state.rowData.map((row, index) => {
//     let newRowData = rowData.map((row, index) => {
//       if (index % 2 === 0) {
//       return { ...row, model: "Even Row" };
//     }
//     return row;
//   });
//   this.setState({ rowData: newRowData });
// }, []);

//function setPriceOnToyota() {
 const setPriceOnToyota = useCallback( e => {
  console.log("setPriceOnToyota 1");
  var rowNode = gridOptions.api.getRowNode('aa');
  //var rowNode = gridRef.gridOptions.api.getRowNode('aa');
  // var rowNode = this.ref.gridRef.api.getRowNode('aa');
  console.log("setPriceOnToyota getRowNode('aa')" + rowNode);
  var newPrice = Math.floor(Math.random() * 100000);
  rowNode.setDataValue('price', newPrice);
 }, []);
//}

//function setDataOnFord() {
const setDataOnFord = useCallback( e => {
  var rowNode = gridOptions.api.getRowNode('bb');
  var newPrice = Math.floor(Math.random() * 100000);
  var newModel = 'T-' + Math.floor(Math.random() * 1000);
  var newData = {
    id: 'bb',
    make: 'Ford',
    model: newModel,
    price: newPrice,
  };
  rowNode.setData(newData);
}, []);
//}



// function setDataOnFord() {
//   var rowNode = gridOptions.api.getRowNode('bb');
//   var newPrice = Math.floor(Math.random() * 100000);
//   var newModel = 'T-' + Math.floor(Math.random() * 1000);
//   var newData = {
//     id: 'bb',
//     make: 'Ford',
//     model: newModel,
//     price: newPrice,
//   };
//   rowNode.setData(newData);
// }

// //https://www.ag-grid.com/archive/26.0.0/react-data-grid/grid-interface/
// // in onGridReady, store the api for later use
// onGridReady = (params) => {
//   // using hooks - setGridApi/setColumnApi are returned by useState
//   setGridApi(params.api);
//   setColumnApi(params.columnApi);

//   // or setState if using components
//   this.setState({
//       gridApi: params.api,
//       columnApi: params.columnApi
//   });
// }

// // use the api some point later!
// somePointLater() {
//   // hooks
//   gridApi.selectAll();
//   columnApi.setColumnVisible('country', visible);

//   // components
//   this.state.gridApi.selectAll();
//   this.state.columnApi.setColumnVisible('country', visible);
// }


  return (
    <div>
 
      {/* Example using Grid's API */}
      <button onClick={buttonListener1}>Unselect Rows</button>
      <button onClick={buttonListener2}>Añadir Rows</button>
      <button onClick={setPriceOnToyota}>Set Price on Toyota</button>
      <button onClick={setDataOnFord}>Set Data On Ford</button>
      {/* <button onClick={updateSort} style="margin-left: 15px;">Sort</button> */}
      <button onClick={updateSort}>Sort</button>
			<button onClick={updateFilter}>Filter</button>
      {/* <button onClick={activateLasers}>Activate Lasers</button> */}
			{/* <button onclick="setDataOnFord()">Set Data on Ford</button> */}
      {/* <button onClick={updateEvenRowData}>Update even rows</button> */}
      {/* <button onClick={() => this.updateEvenRowData()}>
          Update even rows
        </button> */}
      {/* <button className="btn btn-primary mb-3" onClick={this.onAddRow}>Add Row</button> */}
 
      {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
      <div className="ag-theme-alpine" style={{width: 800, height: 500}}>
 
        <AgGridReact
           gridOptions={gridOptions}
            ref={gridRef} // Ref for accessing Grid's API
 
            // rowData={rowData} // Row Data for Rows
 
            // columnDefs={columnDefs} // Column Defs for Columns
            // defaultColDef={defaultColDef} // Default Column Properties
 
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            rowSelection='multiple' // Options - allows click selection of rows
 
             onCellClicked={cellClickedListener} // Optional - registering for Grid Event

            // inside onGridReady, you receive the grid APIs if you want them
            // onGridReady={this.onGridReady}

            />
      </div>
    </div>
  );
 
};

//  render(<Hw2></Hw2>, document.querySelector('#root'));
export default Hw3;
